var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "site footer" },
    [
      _c(
        "b-container",
        { staticClass: "text-center pt-3 pb-3" },
        [
          _c("content-item", {
            attrs: { "bundle-name": "Footer", "item-key": "Footer" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5a20eb6", { render: render, staticRenderFns: staticRenderFns })
  }
}